import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const gmpPostOutboundDataReSyncPlanner = createApi(`GMPResynOutboundSlice`,"POST");

const GMPResynOutboundSlice = createSlice({
  name: 'GMPResynOutboundSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(gmpPostOutboundDataReSyncPlanner.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(gmpPostOutboundDataReSyncPlanner.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(gmpPostOutboundDataReSyncPlanner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GMPResynOutboundSlice.reducer;